var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRightArrowAroundSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33333 7.4165C2.01088 7.4165 1.75 7.67738 1.75 7.99984V12.6665C1.75 12.989 2.01088 13.2498 2.33333 13.2498H7C7.32245 13.2498 7.58333 12.989 7.58333 12.6665V7.99984C7.58333 7.67738 7.32245 7.4165 7 7.4165H2.33333ZM0.25 7.99984C0.25 6.84896 1.18245 5.9165 2.33333 5.9165H7C8.15088 5.9165 9.08333 6.84896 9.08333 7.99984V12.6665C9.08333 13.8174 8.15088 14.7498 7 14.7498H2.33333C1.18245 14.7498 0.25 13.8174 0.25 12.6665V7.99984Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8032 6.13642C11.0961 5.84352 11.5709 5.84352 11.8638 6.13642L13.3335 7.60609L14.8032 6.13642C15.0961 5.84352 15.5709 5.84352 15.8638 6.13642C16.1567 6.42931 16.1567 6.90418 15.8638 7.19708L13.8638 9.19708C13.5709 9.48997 13.0961 9.48997 12.8032 9.19708L10.8032 7.19708C10.5103 6.90418 10.5103 6.42931 10.8032 6.13642Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 2C7.25 1.58579 7.58579 1.25 8 1.25H10.6667C12.5535 1.25 14.0833 2.77979 14.0833 4.66667V8.66667C14.0833 9.08088 13.7475 9.41667 13.3333 9.41667C12.9191 9.41667 12.5833 9.08088 12.5833 8.66667V4.66667C12.5833 3.60821 11.7251 2.75 10.6667 2.75H8C7.58579 2.75 7.25 2.41421 7.25 2Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRightArrowAroundSquare);
export default __webpack_public_path__ + "static/media/icon-right-arrow-around-square.5f18e5e107ecda92a80f5224897de790.svg";
export { ForwardRef as ReactComponent };